import styled from 'styled-components';
import PropTypes from 'prop-types';

const SvgBtn = styled.button`
  ${props => props.right && 'margin-left: auto;'}
  background: transparent;
  border: none;
  cursor: pointer;
  padding: ${props => props.padding || 0};
  margin: ${props => props.margin || 0};
  outline: ${props => props.outline || 'initial'};
  display: table-cell;
  & > svg {
    display: table-cell;
    margin: auto;
  }
  ${props => props.width && `width: ${props.width}`};
  ${props => props.height && `height: ${props.height}`};
  ${props => props.greyBorder && `
    border: 1px solid #E5E8E1;
    border-radius: 2px;
  `}
  ${props => props.opaque && `
    background: white;
  `}
`;

SvgBtn.propTypes = {
  opaque: PropTypes.bool,
  greyBorder: PropTypes.bool,
  padding: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

export default styled(SvgBtn)``;
